<template>
  <div class="bmi">
    <canvas class="bmi-canvas" ref="bmi"> </canvas>
    <div class="bmi-content">
      <div class="text-list">
        <div
          class="text-item"
          :class="{
            'text-item-active': curIndex == index,
            'last-text-active':
              curIndex == index && index == itemList.length - 1
          }"
          :style="{ transform: 'rotate(' + item.rotate + 'deg)' }"
          v-for="(item, index) in itemList"
          :key="index"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="num-list">
        <div
          class="num-item"
          :class="{ 'num-item-active': curIndex == index }"
          :style="{ transform: 'rotate(' + item.rotate + 'deg)' }"
          v-for="(item, index) in bmiList"
          :key="index"
        >
          {{ item.value }}
        </div>
      </div>
      <div
        class="bmi-point"
        :style="{
          transform: 'translate(-50%,0%) rotate(' + curRotate + 'deg)'
        }"
      ></div>
      <div class="circle"></div>
      <div class="bmi-num">{{ value | filterBmi }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      curBmi: 0, //当前bmi值
      curRotate: -90,
      initRotate: -90,
      cWidth: 0, //canvas宽度
      cHeight: 0, //canvas高度
      timer: null, //全局定时器
      bmiList: [
        {
          rotate: -90 + 6,
          value: 16
        },
        {
          rotate: -90 + 36 * 1,
          value: 18.5
        },
        {
          rotate: -90 + 36 * 2,
          value: 24
        },
        {
          rotate: -90 + 36 * 3,
          value: 28
        },
        {
          rotate: -90 + 36 * 4,
          value: 31
        },
        {
          rotate: -90 + 36 * 5 - 6,
          value: 35
        }
      ],
      itemList: [
        {
          text: '偏瘦',
          color: '#58C2A5',
          rotate: '-71',
          min: 16,
          max: 18.5
        },
        {
          text: '正常',
          color: '#53B5BE',
          rotate: '-36',
          min: 18.6,
          max: 24
        },
        {
          text: '偏重',
          color: '#63A4E4',
          rotate: '0',
          min: 24.1,
          max: 28
        },
        {
          text: '肥胖',
          color: '#6F7DEE',
          rotate: '37',
          min: 28.1,
          max: 31
        },
        {
          text: '重度肥胖',
          color: '#7650FF',
          rotate: '73',
          min: 31.1,
          max: 35
        }
      ],
      ctx: null, //绘画上下文
      circleWidth: 35,
      curCircleWidth: 35,
      circleActiveWidth: 42,
      radiu1: 95, // 内圆半径
      bottom: 30, //距离底部的距离
      spaceAngle: Math.PI / 180
    }
  },
  filters: {
    filterBmi(bmi) {
      return bmi.toFixed(1)
    }
  },
  computed: {
    curIndex() {
      let res
      for (let i = 0; i < this.itemList.length; i++) {
        if (
          this.value >= this.itemList[i].min &&
          this.value <= this.itemList[i].max
        ) {
          res = i
          break
        }
      }
      if (res === undefined) {
        res = this.value <= this.itemList[0].min ? 0 : this.itemList.length - 1
      }
      return res
    }
  },
  watch: {
    value() {
      this.curCircleWidth = 35
      this.init(true)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.computedRotate()
      let canvas = this.$refs.bmi
      canvas.width = canvas.offsetWidth
      canvas.height = canvas.offsetHeight
      this.cWidth = canvas.width
      this.cHeight = canvas.height
      this.ctx = canvas.getContext('2d')
      this.animateCal()
    },
    computedRotate() {
      let itemAngle = (180 - (this.itemList.length - 1)) / 5
      let total =
        this.itemList[this.curIndex].max - this.itemList[this.curIndex].min
      let cur = this.value - this.itemList[this.curIndex].min
      cur = cur < 0 ? 0 : cur
      let per = cur / total
      per = per > 1 ? 1 : per
      this.curRotate =
        this.initRotate + (itemAngle + 1) * this.curIndex + itemAngle * per
      console.log(this.curIndex)
      console.log(this.curRotate)
    },
    //canvas动画效果
    animateCal() {
      this.timer = setInterval(() => {
        if (this.curCircleWidth > this.circleActiveWidth) {
          clearInterval(this.timer)
          this.curCircleWidth = this.circleActiveWidth
          this.drawFrame()
          return
        }
        this.drawFrame()
        this.curCircleWidth = this.curCircleWidth + 2
      }, 20)
    },
    drawFrame() {
      this.ctx.clearRect(0, 0, this.cWidth, this.cHeight)
      this.drawItem(this.ctx)
    },
    // 绘制扇形
    drawItem(context) {
      let x = this.cWidth / 2
      let y = this.cHeight
      context.save()
      let curAngle = -Math.PI
      let angleItem =
        (Math.PI - this.spaceAngle * (this.itemList.length - 1)) /
        this.itemList.length
      for (let i = 0; i < this.itemList.length; i++) {
        context.beginPath()
        //context.lineCap = "round";
        context.strokeStyle = this.itemList[i].color
        context.lineWidth =
          i == this.curIndex ? this.curCircleWidth : this.circleWidth //设置线宽
        var radius =
          x - (this.circleActiveWidth - this.circleWidth) - this.circleWidth / 2
        if (i === this.curIndex) {
          radius =
            x -
            (this.circleActiveWidth - this.curCircleWidth) -
            this.curCircleWidth / 2
        }
        context.arc(x, y, radius, curAngle, curAngle + angleItem, false)
        context.stroke()
        context.closePath()
        // context.restore();
        curAngle = curAngle + angleItem + this.spaceAngle
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bmi {
  width: 100%;
  height: 100%;
  position: relative;
  .bmi-content {
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    .text-list {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .text-item {
        position: absolute;
        height: 100%;
        width: 100%;
        padding-bottom: 134px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        transform-origin: center bottom;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(255, 255, 255, 0.7);
        line-height: 18px;
      }
      .text-item-active {
        font-size: 20px;
        line-height: 26px;
        font-weight: 500;
        color: #ffffff;
      }
      .last-text-active {
        font-size: 14px;
      }
    }
    .num-list {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .num-item {
        position: absolute;
        height: 100%;
        width: 100%;
        padding-bottom: 104px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        transform-origin: center bottom;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(255, 255, 255, 0.7);
        line-height: 17px;
      }
    }
    .circle {
      width: 190px;
      height: 190px;
      border-radius: 50%;
      background-color: rgb(83, 71, 115);
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 1;
      transform: translate(-50%, 47%);
    }
    .bmi-num {
      z-index: 2;
      position: absolute;
      bottom: 0;
      left: 50%;
      height: 66px;
      transform: translate(-50%, 0%);
      font-size: 50px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;
      color: #ffffff;
      line-height: 66px;
    }
    .bmi-point {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform-origin: center bottom;
      width: 4px;
      height: 143px;
      background-color: #fff;
      border-radius: 2px 2px 0px 0px;
      transform: translate(-50%, 0%) rotate(-90deg);
      transition: all 0.5s ease;
    }
  }
}
.bmi-canvas {
  width: 100%;
  height: 100%;
}
</style>
